import { createReducer, on } from '@ngrx/store';
import {
  projectExpenseAdded,
  projectExpenseDeleted,
  projectExpenseUpdated,
  setProjectExpenses,
} from './project-expenses.actions';
import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { ProjectExpenseModel } from '../../../models/finance/expense.model';

export interface ProjectExpensesState extends EntityState<ProjectExpenseModel> {}

export const projectExpensesAdapter: EntityAdapter<ProjectExpenseModel> =
  createEntityAdapter<ProjectExpenseModel>();

const initialState: ProjectExpensesState = projectExpensesAdapter.getInitialState();

export const projectExpensesReducer = createReducer(
  initialState,

  // SET (replace many)
  on(setProjectExpenses, (state, { payload }): ProjectExpensesState => {
    return projectExpensesAdapter.setMany(payload, state);
  }),

  // ADD (one or many)
  on(projectExpenseAdded, (state, { payload }): ProjectExpensesState => {
    if (Array.isArray(payload)) {
      return projectExpensesAdapter.addMany(payload, state);
    }
    return projectExpensesAdapter.addOne(payload, state);
  }),

  // UPDATE/UPSERT (one or many)
  on(projectExpenseUpdated, (state, { payload }): ProjectExpensesState => {
    if (Array.isArray(payload)) {
      return projectExpensesAdapter.upsertMany(payload, state);
    }
    return projectExpensesAdapter.upsertOne(payload, state);
  }),

  // DELETE (one or many)
  on(projectExpenseDeleted, (state, { payload }): ProjectExpensesState => {
    if (Array.isArray(payload)) {
      return projectExpensesAdapter.removeMany(
        payload.map((e) => e.id),
        state,
      );
    }
    return projectExpensesAdapter.removeOne(payload.id, state);
  }),
);
